import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'typeface-roboto/index.css'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import 'vuetify/src/stylus/app.styl'

//  Locales
import en from 'vuetify/es5/locale/en'
import it from 'vuetify/es5/locale/it'

Vue.use(Vuetify, {
    lang: {
        locales: { en, it },
        current: navigator.language.substring(0, 2)
    },
    theme: {
        primary: '#0d2549',
        secondary: '#1A498F',
        accent: '#00838f',
        error: '#cf432c',
        info: '#6200ee',
        success: '#56AE5A',
        warning: '#ff8800'
    },
    directives: {
        Ripple //  Necessario per utilizzare la direttiva anche nei componenti funzionali (con funzione render(h))
    }
})
